if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;

        if (!this.form || !this.submitButton) return;

        const variantInput = this.form.querySelector('[name="id"]');
        if (variantInput) {
          variantInput.disabled = false;
        }

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(event) {
        event.preventDefault();

        if (!this.form || !this.submitButton) return;

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }

        const formData = new FormData(this.form);

        const variantId = formData.get('id');
        if (!variantId) {
          this.handleErrorMessage('Please select the required product options before adding to cart.');
          this.resetSubmitButton();
          return;
        }

        if (!formData.get('quantity')) {
          formData.set('quantity', '1');
        }

        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          try {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map(function (section) {
                return section.id;
              })
            );
            formData.append('sections_url', window.location.pathname);

            if (typeof this.cart.setActiveElement === 'function') {
              this.cart.setActiveElement(document.activeElement);
            }
          } catch (error) {
            console.warn('Emerald Rest cart sections could not be prepared:', error);
          }
        }

        fetch(this.getCartAddUrl(), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return {
                ok: response.ok,
                status: response.status,
                data: data
              };
            });
          })
          .then(
            function (result) {
              const response = result.data;

              if (!result.ok || response.status) {
                this.error = true;

                const errorMessage =
                  response.description ||
                  response.message ||
                  'This product could not be added to cart. Please check your selections and try again.';

                this.handleErrorMessage(errorMessage);

                this.publishCartError(errorMessage, response);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                const buttonText = this.submitButton.querySelector('span');

                if (soldOutMessage && buttonText) {
                  buttonText.classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                }

                return;
              }

              this.error = false;
              this.publishCartUpdate(response);

              if (this.cart && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(response);
              } else {
                this.refreshCartFallback();
              }
            }.bind(this)
          )
          .catch(
            function (error) {
              console.error('Emerald Rest add-to-cart error:', error);
              this.error = true;
              this.handleErrorMessage('There was a problem adding this product to cart. Please refresh and try again.');
            }.bind(this)
          )
          .finally(
            function () {
              this.resetSubmitButton();

              if (this.cart && this.cart.classList && this.cart.classList.contains('is-empty')) {
                this.cart.classList.remove('is-empty');
              }
            }.bind(this)
          );
      }

      getCartAddUrl() {
        if (window.routes && window.routes.cart_add_url) {
          return window.routes.cart_add_url;
        }

        return '/cart/add';
      }

      resetSubmitButton() {
        if (!this.submitButton) return;

        this.submitButton.classList.remove('loading');

        if (!this.error) {
          this.submitButton.removeAttribute('aria-disabled');
        } else {
          this.submitButton.removeAttribute('aria-disabled');
        }

        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) {
          if (errorMessage) {
            console.warn('Emerald Rest product form error:', errorMessage);
          }
          return;
        }

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (this.errorMessage && errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      publishCartUpdate(response) {
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: response.variant_id,
              cartData: response
            });
          }
        } catch (error) {
          console.warn('Emerald Rest cart update event could not be published:', error);
        }
      }

      publishCartError(errorMessage, response) {
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: response && response.variant_id ? response.variant_id : null,
              errors: errorMessage,
              message: errorMessage
            });
          }
        } catch (error) {
          console.warn('Emerald Rest cart error event could not be published:', error);
        }
      }

      refreshCartFallback() {
        fetch('/cart.js', {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        })
          .then(function (response) {
            return response.json();
          })
          .then(function () {
            const cartDrawer = document.querySelector('cart-drawer');

            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
            }
          })
          .catch(function () {
            window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
          });
      }
    }
  );
}